/* camelcase,no-undef */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// --- Styled Components ---
const RolesContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 0px;
  width: 100%;
 
`;

const RoleTabItem = styled.div`
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 500;
  ${'' /* color: ${(props) => (props.active ? "#DA6C74" : "#184A61")}; */}
  color:#184A61;
  margin-right: 30px;
  cursor: pointer;
  padding-bottom: 12px;
  position: relative;
  transition: all 0.2s ease-in-out;

  /* Active indicator line */
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0;
    left: 0;
    background-color: ${(props) => (props.active ? "#DA6C74" : "transparent")};
    transition: background-color 0.2s ease-in-out;
  }

  &:hover {
    color: #DA6C74;
  }
`;

// --- Configuration ---
export const ROLE_TYPES = [
  { value: "ADMIN", label: "Admin" },
  { value: "CHAMPION", label: "Champion" },
  { value: "MANAGER", label: "Manager" },
  { value: "CONTENT_CREATOR", label: "Content Creator" },
];

const RolesNavigation = ({ 
  activeRole, 
  onRoleChange, 
  t 
}) => (
  <RolesContainer>
    {ROLE_TYPES.map((role) => (
      <RoleTabItem
        key={role.value}
        active={activeRole === role.value}
        onClick={() => onRoleChange(role.value)}
      >
        {/* Apply translation if 't' function is provided, otherwise fallback to label */}
        {t ? t(role.label) : role.label}
      </RoleTabItem>
    ))}
  </RolesContainer>
);

RolesNavigation.propTypes = {
  activeRole: PropTypes.string.isRequired,
  onRoleChange: PropTypes.func.isRequired,
  t: PropTypes.func,
};

export default RolesNavigation;